module.exports = __webpack_public_path__ + "static/media/landing_background1.80d34dda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/other/landing_background1.jpg
// module id = 309
// module chunks = 0